<template>
  <c-view>
    <c-page>
      <c-navbar v-if="nav_type"></c-navbar>
      <c-content class="page_content">
        <div class="group bg_img1"></div>
        <div class="group bg_img2"></div>
        <div class="group bg_img3"></div>
        <div class="group bg_img4"></div>
        <div class="group bg_img5"></div>
        <div class="group bg_img6"></div>
      </c-content>
      <div class="bottom_btn">
        <a href="javascript:;"
           @click="gotonewdealer">成为代理商</a>
      </div>
    </c-page>
    <transition name="slide-right"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
@import './index';
</style>
<script>
export default {
  data () {
    return {
      nav_type: ''
    }
  },
  components: {},
  created () {
  },
  methods: {
    gotonewdealer () {
      window.location.href = 'https://jinshuju.net/f/3xlCN2'
    }
  },
  mounted () {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.nav_type = false
    } else if (/(Android)/i.test(navigator.userAgent)) {
      this.nav_type = true
    }
  },
  events: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?22794c0c